export const setSectionsToSpy = (arr, headers, offset = 0) => {
  const sectionDistances = arr.reduce((acc, value, index) => {
    const item = index === 0 ? value : value - offset
    const pair = [item, arr[index + 1] - offset]

    return [...acc, pair]
  }, [])

  const removedLastIndexSectionDistances = sectionDistances.splice(0, sectionDistances.length - 1)

  return removedLastIndexSectionDistances.reduce((obj, value, index) => {
    return {...obj, [headers[index]]: { range: value }}
  }, {})
}
